import React, {useMemo} from 'react';
import {setUpNewPlanContactIdField as shellPlanContactIdField} from './builderSetUpNewFields';
import AutoField, {SelectOption} from '../../../components/AutoForm/AutoFieldNew';
import {getContactName} from '../../../utils/getContactName';
import {useAccountInterestedParties} from '../../../hooks/useAccountInterestedParties';

export const BuilderPlanInterestedPartyField: React.FC<{
  formikKeyPrefix: string;
  label?: string;
}> = ({formikKeyPrefix, label}) => {
  const {interestedParties, interestedPartiesLoading} = useAccountInterestedParties();

  const contactOptions: SelectOption[] = useMemo(
    () =>
      interestedParties
        .filter((ip) => ip.contact !== null)
        .map((ip) => {
          return {
            label: getContactName(ip.contact!),
            value: ip.contact!.id,
          };
        }),
    [interestedParties]
  );

  return (
    <AutoField
      field={{
        ...shellPlanContactIdField,
        label: label || shellPlanContactIdField.label,
        id: `${formikKeyPrefix}.contactId`,
        options: contactOptions || [],
        loading: interestedPartiesLoading,
      }}
    />
  );
};
